/* eslint-disable import/prefer-default-export */
import * as req from 'api/actions';
// import alert from 'react-s-alert';
import * as c from './constant';

export const getProvinceList = (payload, callback) =>
  req.list(
    c.GET_PROVINCE_LIST,
    '/api/v1/administrators/address/provinces',
    payload,
    callback
  );

export const getRegionsList = (payload, callback) =>
  req.list(
    c.GET_REGION,
    '/api/v1/administrators/address/regions',
    payload,
    callback
  );

export const showProvinceSelected = (id, payload, callback) =>
  req.item(
    c.GET_SELECTED_PROVINCE,
    `/api/v1/administrators/address/provinces/${id}`,
    payload,
    callback
  );


export const getMunicipalities = (id, payload, callback) =>
  req.list(
    c.GET_MUNICIPALITIES,
    `/api/v1/administrators/address/municipalities`,
    payload,
    callback
  );

  export const clearTransaction = () => req.setList(c.GET_PROVINCE_LIST, []);